import React from 'react'
import dayjs from 'dayjs'
import { Value } from '../../elements'

export const getMobileFields = () => [
  {
    key: 'created_at',
    label: 'Дата обращения',
    render: (val) => (val ? dayjs(val).format('DD.MM.YYYY') : <Value data={val} />),
  },
  {
    key: 'address',
    label: 'Адрес',
    render: (val) => <Value data={val} />,
  },
  {
    key: 'name',
    label: 'ФИО',
    render: (val) => <Value data={val} />,
  },
  {
    key: 'phone',
    label: 'Телефон',
  },
]


